import { SVGProps } from "react";

const Cambodia = (props: SVGProps<SVGSVGElement>) => {
  const { width = 24, height = 24 } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12C2 13.839 2.44074 15.5687 3.2159 17.0769L12 18L20.7841 17.0769C21.5593 15.5687 22 13.839 22 12C22 10.161 21.5593 8.43125 20.7841 6.92308L12 6L3.2159 6.92308C2.44074 8.43125 2 10.161 2 12H2Z"
        fill="#D80027"
      />
      <path
        d="M3.21582 7.21738H20.784C19.088 4.10895 15.7903 2 11.9999 2C8.20949 2 4.91187 4.10895 3.21582 7.21738Z"
        fill="#0052B4"
      />
      <path
        d="M11.9999 22.0001C15.7903 22.0001 19.088 19.8912 20.784 16.7827H3.21582C4.91187 19.8912 8.20949 22.0001 11.9999 22.0001Z"
        fill="#0052B4"
      />
      <path
        d="M15.2 13.6875V12.375H14.4V10.625L13.6 9.75001L12.8 10.625V8.875L12 8L11.2 8.875V10.625L10.4 9.75001L9.59998 10.625V12.375H8.80001V13.6875H8V15H16V13.6875H15.2Z"
        fill="#F8F9F9"
      />
    </svg>
  );
};

export default Cambodia;
